<template>
  <div class="wh100">
    <xh-filter-layout title="网站留言">
      <template #content>
        <MyTable ref="mytable" :url="table.url" :params="form" :method="table.method" stripe border fit :customSort="true">
          <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
          <el-table-column prop="msg_content" label="留言内容" align="center"  show-overflow-tooltip min-width="200"></el-table-column>
          <el-table-column prop="link_man" label="姓名" align="center"></el-table-column>
          <el-table-column prop="link_phone" label="手机号码" align="center"></el-table-column>
          <el-table-column prop="msg_time" label="留言时间" align="center" sortable></el-table-column>
          <el-table-column prop="ip_address" label="IP地址" align="center"></el-table-column>
        </MyTable>
      </template>
    </xh-filter-layout>
  </div>
</template>
<script>
import XhFilterLayout from "@/components/XhComponents/XhFilterLayout";
import MyPanel from "@/components/Pannel/Pannel";
import MyTable from "@/components/XhComponents/XhPageTable";
export default{
  components: { XhFilterLayout, MyPanel, MyTable},
  data(){
    return{
      title:'WebsiteMessage',
      form: {},
      table: {
        method: "POST",
        url: "/WebsiteMessage/getData",
        pageSize: 50,
      },
      checkRowId: [],
      timer:"",
      dialog: {
        title: "添加",
        visible: false,
        editRow: {}
      },
    }
  },
  methods:{
    query(){
      this.$refs.mytable.reload();
    },
  },
  computed: { },
  mounted() { },
  created() { },
  watch: { },
}


</script>
